import { render } from "./driver-requests.vue?vue&type=template&id=22eb8f22&scoped=true"
import script from "./driver-requests.vue?vue&type=script&lang=js"
export * from "./driver-requests.vue?vue&type=script&lang=js"

import "./driver-requests.vue?vue&type=style&index=0&id=22eb8f22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22eb8f22"]])

export default __exports__